// eslint-disable-next-line import/no-extraneous-dependencies
import Vuex from 'vuex';
import { newDiscoverModule } from './modules/discover';
import { abTestModule } from './modules/ab-test';
import { feedMoudle } from './modules/feed';
import { userModule } from './modules/user';
import { isLogin } from '~/common/login';

const createStore = () => {
    const store = new Vuex.Store({
        state: {
            startup: {},
            isLogin: false,
            videoList: [],
            discoverFeeds: [] as Array<any>,
            discoverCursor: '',
            clickedPicture: {},
            topicName: '',
            tgPraiseAmountList: [],
            newDiscoverExpValue: '',
            host: '',
            /**
             * @zh 是否展示弹窗 - 引导用户打开通知的弹窗
             */
            showNotificationPopup: false,
        },
        mutations: {
            setStartup(state, data) {
                state.startup = data;
            },
            setIsLogin(state, data) {
                state.isLogin = data;
            },
            setVideoList(state, data) {
                state.videoList = data;
            },
            setClickedPicture(state, data) {
                state.clickedPicture = data;
            },
            setDiscoverFeeds(state, { feeds }) {
                const formateArr = [] as Array<any>;
                feeds?.forEach((item: any) => {
                    const formateFeedsItem = {
                        photo_id_str: item.photo_id_str,
                        view_count: item.view_count,
                        kwai_id: item.kwai_id,
                        user_name: item.user_name,
                        user_id: item.user_id,
                        caption: item.caption,
                        cover_first_frame_urls: [{ url: item.cover_first_frame_urls[0].url }],
                        headurls: [{ url: item?.headurls[0]?.url }],
                        like_count: item.like_count,
                        comment_count: item?.comment_count,
                        forward_count: item?.forward_count,
                    };
                    formateArr.push(formateFeedsItem);
                });
                // console.log(feeds)
                state.discoverFeeds = [...state.discoverFeeds, ...formateArr];
            },
            // 初始化请求你 把之前的数据都冲了。
            setInitDiscoverFeeds(state, { feeds }) {
                state.discoverFeeds = [...feeds];
            },
            setDiscoverCursor(state, { cursor }) {
                state.discoverCursor = cursor;
            },
            setTopicName(state, data) {
                state.topicName = data;
            },
            setTgPraiseAmountList(state, data) {
                state.tgPraiseAmountList = data;
            },
            setNewDiscoverExpValue(state, expValue: string) {
                if (!state.newDiscoverExpValue) {
                    state.newDiscoverExpValue = expValue;
                }
            },
            setHost(state, data) {
                state.host = data;
            },
            setShowNotificationPopup(state, data: boolean) {
                state.showNotificationPopup = data;
            },
        },
        actions: {
            // 当csr时 无法调用这个
            async nuxtServerInit({ commit }, ctx) {
                const { $axios } = ctx;
                const res = await $axios.$$post('overseaAPI::/rest/o/w/pwa/startup', {
                    shareDeviceId: ctx.route?.query?.share_device_id,
                });

                // 拦截国内ip
                if (res.result === 5002) {
                    ctx.redirect('/error');
                }

                if (res.result === 1) {
                    commit('setStartup', res.data || {});
                }

                commit('setHost', ctx?.req?.headers?.host || '');
            },
            async getIsLogin({ commit }, ctx) {
                // const { $axios } = ctx
                const res = await isLogin();
                commit('setIsLogin', res);
            },
            async getDiscoverList({ commit, state }, ctx) {
                const { $axios } = ctx;
                const feedRes = await $axios.$$post('overseaAPI::/rest/o/w/pwa/feed/search', {
                    type: 'video',
                    searchWord: encodeURIComponent(decodeURIComponent(ctx.route.params.content || '')),
                    fromPage: 'PWA_SEARCH',
                    pcursor: state.discoverCursor || '',
                    count: 12, // 单次请求的post数量
                });
                if (feedRes.result === 1) {
                    commit('setDiscoverFeeds', { feeds: feedRes.feeds });
                    commit('setDiscoverCursor', { cursor: feedRes.cursor });
                } else {
                    commit('setDiscoverCursor', { cursor: 'no_more' });
                }
            },
            // v2是为了控制返回时机
            async getDiscoverListV2({ commit, state }, ctx) {
                const { $axios } = ctx;
                return $axios.$$post('overseaAPI::/rest/o/w/pwa/feed/search', {
                    type: 'video',
                    searchWord: encodeURIComponent(decodeURIComponent(ctx.route.params.content || '')),
                    fromPage: 'PWA_SEARCH',
                    pcursor: state.discoverCursor || '',
                    count: 8, // 单次请求的post数量
                });
            },
            async initGetDiscoverList({ commit, state }, ctx) {
                const { $axios } = ctx;
                const feedRes = await $axios.$$post('overseaAPI::/rest/o/w/pwa/feed/search', {
                    type: 'video',
                    searchWord: encodeURIComponent(decodeURIComponent(ctx.route.params.content || '')),
                    fromPage: 'PWA_SEARCH',
                    pcursor: '',
                    count: 8, // 单次请求的post数量
                });
                if (feedRes.result === 1) {
                    commit('setInitDiscoverFeeds', { feeds: feedRes.feeds });
                    commit('setDiscoverCursor', { cursor: feedRes.cursor });
                } else {
                    commit('setDiscoverCursor', { cursor: 'no_more' });
                }
            },
            // tg 打上金额列表
            async initTgPraiseAmounts({ commit, state }, ctx) {
                try {
                    const { $axios } = ctx;
                    const { result, errorMsg, data } = await $axios.$$post('https://m.kwai.com/rest/o/w/kconf/loggedOut', {
                        paths: ['overseaGrowth.newPushMessage.tgPayPraiseAmount'],
                    });
                    if (result === 1 && data?.['overseaGrowth.newPushMessage.tgPayPraiseAmount']) {
                        const tgPraiseAmountList = JSON.parse(data?.['overseaGrowth.newPushMessage.tgPayPraiseAmount']);
                        commit('setTgPraiseAmountList', tgPraiseAmountList);
                        console.log('tg miniApp: ', 'kconf fetch success');
                    }
                } catch (error) {
                    console.log(error);
                }
            },
        },
        modules: {
            newDiscoverModule,
            abTestModule,
            feedMoudle,
            userModule,
        },
    });
    return store;
};
export default createStore;
